import React from "react";
import { CheckOutlined, DeleteOutlined, EditOutlined, EllipsisOutlined, EyeOutlined } from '@ant-design/icons';
import { Avatar, Card, Tag } from 'antd';
import { CardBody } from "reactstrap";
import { toast, ToastContainer } from 'react-toastify';
import "../../../common/css/button.css"

const { Meta } = Card;

const CardItem = ({ companies, onDetail, onEdit, onComplete, onDelete }) => {

  const handleComplete = (company) => {
    if (company?.kycValidated === true) {
      toast.success(`Votre entreprise ${company?.name} est déjà complète`, {
        autoClose: 2000
      });
    } else {
      onComplete(company);
    }
  }; 

  return (
    <>
      <ToastContainer position="top-center" style={{width: '380px'}}/>
      {companies?.map((company) => {
        const { name, kycStatus, kycValidated, developerAccounts } = company || {};
        const developpers = Array.isArray(developerAccounts) ? developerAccounts : [];

        const etatText = kycValidated === true ? "Complète" : kycValidated === false ? "Incomplet" : "Indéfini";
        const etatColor = kycValidated === true ? "green" : kycValidated === false ? "red" : "grey";

        return (
          <Card key={company.id} className="card-animate">
            <CardBody>
              <Card
                actions={[
                  <EyeOutlined key="detail" className="btn btn-soft-primary"  title="Détail" onClick={() => onDetail(company)} />,
                  <EditOutlined key="edit" className="btn btn-soft-danger"  title="Modifier" onClick={() => onEdit(company)} />,
                  <DeleteOutlined key="delete" className="btn btn-soft-danger"  title="Supprimer" onClick={() => onDelete(company.id)} />,
                  <CheckOutlined key="valid" className="btn btn-soft-success" title="Completer" onClick={() => handleComplete(company) } 
                  />,
                  <EllipsisOutlined key="ellipsis" />,
                ]}
              >
                <Meta
                  avatar={<Avatar src="https://api.dicebear.com/7.x/miniavs/svg?seed=8" />}
                  title={`Entreprise : ${name}`}
                  description={
                    <>
                      Etat : <Tag color={etatColor}>{etatText}</Tag>
                    </>
                  }
                />
                <br />
                <div className="d-flex justify-content-between">
                  <div className="text-muted">
                    <strong>Statut : </strong> {kycStatus || "Non défini"}
                  </div>
                  <div className="text-muted">{developpers?.length || "Pas d' "} applications</div>
                </div>
              </Card>
            </CardBody>
          </Card>
        );
      })}
    </>
  );
};

export default CardItem;
